import * as MUIICon from "@mui/icons-material";
import * as React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import { Box, Grid, List, ListItemButton } from "@mui/material";
import { Global_Data } from "../../globalData/GlobalData";
import ComponentLoadingBoundary from "../Loading/ComponentLoadingBoundary";
import useButtonActionAccess from "../ButtonComponent/useButtonActionAccess";

export default function ButtonDropdown({
  data,
  handleclickdata,
  isResponseArrived,
  formName,
  formData,
  formValues
}) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen(previous => !previous);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const Icons = MUIICon[data?.component?.sIcon];
  const { token } = Global_Data();
  const listItems = React.useMemo(
    () =>
      (data?.child || []).filter(
        item => item?.component?.sType === "BUTTONLISTITEM"
      ),
    [data?.child]
  );
  const accessItems = React.useMemo(() => [data, ...listItems], [data, listItems]);
  const { isAllowed, isLoading } = useButtonActionAccess({
    items: accessItems,
    formName,
    formData,
    formValues,
    token
  });
  const motherAllowed = isAllowed(data);
  const hasAllowedChild = listItems.some(isAllowed);

  React.useEffect(() => {
    if (!hasAllowedChild) setOpen(false);
  }, [hasAllowedChild]);

  const sharedMainButtonSx = [
    data?.component?.sProps?.sx || {},
    {
      flexGrow: 1,
      whiteSpace: "nowrap"
    }
  ];

  const sharedToggleButtonSx = [
    data?.component?.sProps?.sx || {},
    {
      flex: "0 0 auto"
    }
  ];

  return (
    <Grid item>
      <ComponentLoadingBoundary
        loading={isLoading}
        label={`Loading ${data?.component?.sLabel || data?.component?.sName}`}
        minHeight={36}
        size={20}
      >

      <Box
        sx={{
          display: "inline-grid",
          verticalAlign: "top"
        }}
      >
      {listItems.map(item => (
        <Box
          component="span"
          aria-hidden="true"
          key={`button-dropdown-sizer-${item?.component?.sName || item?.component?.sLabel}`}
          sx={{
            gridArea: "1 / 1",
            height: 0,
            minWidth: "max-content",
            overflow: "hidden",
            px: 2,
            visibility: "hidden",
            whiteSpace: "nowrap"
          }}
        >
          {item?.component?.sLabel || ""}
        </Box>
      ))}

      {data?.component?.sAdornPosition == "End" ? (
        <>
        {/* {JSON.stringify(data.grid_props)}
        ====
        {JSON.stringify(data.component.sProps)} */}
          <ButtonGroup
            ref={anchorRef}
            sx={[data.component.sProps, { gridArea: "1 / 1", width: "100%" }]}
            {...data.component.sProps}
            size="small"
            aria-label="Button group with a nested menu"
          >
            <Button
              id={data?.component?.sName}
              onClick={e => handleclickdata(e, data?.component, data.data, data)}
              disabled={!motherAllowed || !isResponseArrived}
              size="small"
              {...data.component.sProps}
              sx={sharedMainButtonSx}
              // startIcon={startIcon}
              // endIcon={endIcon}
            >
              
              {data.component.sLabel}
            </Button>
            <Button
              id={data?.component?.sName + "_icon"}
              onClick={handleToggle}
              size="small"
              aria-controls={open ? "split-button-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              disabled={!hasAllowedChild || !isResponseArrived}
              {...data.component.sProps}
              sx={sharedToggleButtonSx}
            >
              <Icons { ...data?.component?.sIconProps} />
            </Button>
          </ButtonGroup>
        </>
      ) : (
        <>
          <ButtonGroup
            ref={anchorRef}
            sx={[data.component.sProps, { gridArea: "1 / 1", width: "100%" }]}
            {...data.component.sProps}
            variant="contained"
            size="small"
            aria-label="Button group with a nested menu"
          >
            <Button
              onClick={handleToggle}
              size="small"
              id={data?.component?.sName + "_icon"}
              aria-controls={open ? "split-button-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              disabled={!hasAllowedChild || !isResponseArrived}
              {...data.component.sProps}
              sx={sharedToggleButtonSx}
            >
              <Icons  { ...data?.component?.sIconProps} />
            </Button>
            <Button
              onClick={e => handleclickdata(e, data?.component, data.data, data)}
              disabled={!motherAllowed || !isResponseArrived}
              id={data?.component?.sName}
              {...data.component.sProps}
              sx={sharedMainButtonSx}
              // startIcon={startIcon}
              // endIcon={endIcon}
            >
              {" "}
              {data.component.sLabel}
            </Button>
          </ButtonGroup>
        </>
      )}
      </Box>

      <Popper
        sx={{
          zIndex: 1,
          width: anchorRef.current?.getBoundingClientRect().width || "auto"
        }}
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom"
            }}
          >
            <Paper sx={{ boxSizing: "border-box", width: "100%" }}>
              <ClickAwayListener onClickAway={handleClose}>
                <List sx={{ width: "100%" }}>
                  {/* dwdwdw */}
                  {/* {JSON.stringify(data)} */}
                  {data?.child.map((item, ind) => {
                    const itemDisabled =
                      item?.component?.sType === "BUTTONLISTITEM" &&
                      (!isAllowed(item) || !isResponseArrived);

                    return (
                      <ListItemButton
                        key={`${item?.component?.sName || item?.component?.sLabel || "item"}-${ind}`}
                        disabled={itemDisabled}
                        onClick={() => {
                          if (!itemDisabled) setOpen(false);
                        }}
                        sx={{
                          whiteSpace: "nowrap",
                          width: "100%",
                          "&:hover": {
                            backgroundColor: "#64b5f6"
                          }
                        }}
                      >
                        <ChildDropDown
                          handleclickdata={handleclickdata}
                          item={item}
                          disabled={itemDisabled}
                          dropDownSName={data?.component?.sName}
                          isResponseArrived={isResponseArrived}
                          formName={formName}
                          formData={formData}
                          formValues={formValues}
                        />
                      </ListItemButton>
                    );
                  })}
                </List>
                {/* <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      disabled={index === 2}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList> */}
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      </ComponentLoadingBoundary>
    </Grid>
  );
} // import {Box, Button, Grid, List, ListItem, Popover } from "@mui/material";
// import React from "react";
// import * as MUIICon from "@mui/icons-material";

// function ButtonDropdown({ data, handleclickdata }) {
//   const [anchorEl1, setAnchorEl1] = React.useState(null);
//   const open1 = Boolean(anchorEl1);
//   const id = open1 ? "simple-popover" : undefined;

//   const handleClick2 = event => {
//     event.stopPropagation();
//     setAnchorEl1(event.currentTarget);
//   };

//   const handleClose2 = () => {
//     setAnchorEl1(null);
//   };

//   let startIcon = null;
//   let endIcon = null;
//   const Icons = MUIICon[data?.component?.sIcon];

//   if (data?.component?.sAdornPosition === "Start") {
//     startIcon = <Icons aria-describedby={id} onClick={handleClick2} />;
//   } else if (data?.component?.sAdornPosition === "End") {
//     endIcon = <Icons aria-describedby={id} onClick={handleClick2} />;
//   }

//   return (
//     <Grid item {...data?.grid_props}>
//       <Button
//         sx={{
//           border: "none",
//           "&:hover": {
//             border: "none"
//           }
//         }}
//         onClick={e => handleclickdata(e, data?.component, data.data, data)}
//         {...data.component.sProps}
//         startIcon={startIcon}
//         endIcon={endIcon}
//       >
//         {data.component.sLabel}
//       </Button>

//       <Popover
//         id={id}
//         open={open1}
//         anchorEl={anchorEl1}
//         onClose={handleClose2}
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "center"
//         }}
//         transformOrigin={{
//           vertical: "top",
//           horizontal: "center"
//         }}
//       >
//         <List>
//           {data?.child.map((item, ind) => (
//             <ListItem key={ind}>
//               <ChildDropDown handleclickdata={handleclickdata} item={item} />
//             </ListItem>
//           ))}
//         </List>
//       </Popover>
//     </Grid>
//   );
// }

// export default ButtonDropdown;

function ChildDropDown({
  handleclickdata,
  item,
  disabled = false,
  dropDownSName,
  isResponseArrived,
  formName,
  formData,
  formValues
}) {
  let Icons;
  if (item?.component?.sIcon) {
    Icons = MUIICon[item?.component?.sIcon];
  }

  return (
    <>
    {/* {JSON.stringify(item?.component.sIconProps)} */}
      {item.component.sType == "BUTTONLISTITEM" ? (
        <Box
          sx={{
            cursor: disabled ? "default" : "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            width: "100%"
          }}
          onClick={e => {
            if (disabled) return;
            handleclickdata(e, item?.component, item.data, item);
          }}
          {...item?.component.sProps}
          id={dropDownSName ? dropDownSName + "_" + item?.component?.sName : item?.component?.sName}
        >
          {/* {JSON.stringify(item?.component.sAdornPosition)} */}
          {/* {item.component.sName} */}
          {item?.component.sAdornPosition == "Start" && item?.component?.sIcon && <Icons {...item?.component.sIconProps} />}
          {item.component.sLabel}
          {item?.component.sAdornPosition == "End" && item?.component?.sIcon && <Icons {...item?.component.sIconProps} />}
        </Box>
      ) : (
        item.component.sType == "BUTTONDROPDOWN" && (
          <ButtonDropdown
            data={item}
            handleclickdata={handleclickdata}
            isResponseArrived={isResponseArrived}
            formName={formName}
            formData={formData}
            formValues={formValues}
          />
        )
      )}
    </>
  );
}
